import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import Banner from '../../components/section-components/Banner';
import ServicesOne from '../../components/section-components/ServicesOne';
import AboutOne from '../../components/section-components/AboutOne';
import ProjectsOne from '../../components/section-components/ProjectsOne';
import TestimonialTwo from '../../components/section-components/TestimonialTwo';
import Pricing from '../../components/section-components/Pricing';
import TeamOne from '../../components/section-components/TeamOne';
import Counter from '../../components/section-components/Counter';
import NewsOne from '../../components/section-components/NewsOne';
import FooterOne from '../../common/footer/FooterOne';

const HomeOne = () => {
    return (
        <>
        <HeaderOne />
        
        <Banner />
        
        <ServicesOne />
        
        <AboutOne />
        
        <ProjectsOne />
        
        <TestimonialTwo />
        
        <Pricing />
        
        <TeamOne />
        
        <Counter />
        
        <NewsOne />

        <FooterOne />
        </>
    )
}
    
export default HomeOne;